"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingStars = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var RatingStars = function RatingStars(_ref) {
  var _ref$ratingValue = _ref.ratingValue,
      ratingValue = _ref$ratingValue === void 0 ? 0 : _ref$ratingValue;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      rating = _useState2[0],
      setRating = _useState2[1];

  var handleRating = function handleRating(value) {
    setRating(value);
  };

  (0, _react.useEffect)(function () {
    setRating(ratingValue);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: (0, _toConsumableArray2.default)(Array(5)).map(function (_, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "star ".concat(index < rating ? "active" : ""),
        onClick: function onClick() {
          return handleRating(index + 1);
        },
        children: "\u2605"
      }, index);
    })
  });
};

exports.RatingStars = RatingStars;